import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from "@ngrx/store";
import { AuthUserActions } from "./authUser.store";
// replace with your real Order type
import { BubbleAlerts, InteractionPublic, InteractionView } from "./../../../globalTypes/interactions.types";
import { sortByKey } from "../helper/general";

export interface InteractionsState extends EntityState<InteractionPublic> {
  fulfillmentEntriesShowing: {[fulfillmentId: string]: boolean}
  interactions: InteractionPublic[];
  bubbleAlerts: BubbleAlerts;
  isLoading: boolean;
}

const adapter: EntityAdapter<InteractionPublic> = createEntityAdapter<InteractionPublic>();

export const blankBubbles: () => BubbleAlerts = () => ({
  shipping: new Set(),
  banking: new Set(),
  fulfillment: new Set(),
  purchase: new Set(),
  unseen: new Set(),
})

const setBubbles: ( newBubbles?: BubbleAlerts, currentBubbles?: BubbleAlerts ) => BubbleAlerts = (
  newBubbles: BubbleAlerts = blankBubbles(),
  currentBubbles: BubbleAlerts = blankBubbles(),
) => {
  const filly = new Set([...newBubbles.fulfillment, ...currentBubbles.fulfillment])
  console.log({newBubbles, currentBubbles, filly})
  const rtn = {
    shipping: new Set([...newBubbles.shipping, ...currentBubbles.shipping]),
    banking: new Set([...newBubbles.banking, ...currentBubbles.banking]),
    fulfillment: new Set([...newBubbles.fulfillment, ...currentBubbles.fulfillment]),
    purchase: new Set([...newBubbles.purchase, ...currentBubbles.purchase]),
    unseen: new Set([...newBubbles.unseen, ...currentBubbles.unseen]),
  }
  return rtn }

const getInteractionsState = (): InteractionsState => adapter.getInitialState({
  fulfillmentEntriesShowing: {},
  isLoading: true,
  interactions: [],
  bubbleAlerts: blankBubbles(),
});

export const InteractionsPageActions = createActionGroup({
  source: 'INTERACTIONS',
  events: {
    'Interactions Loading': (isLoading: boolean) => ({ isLoading }),
    'Interactions Loaded': props<{ interactions: InteractionPublic[] }>(),
    'Update Cart': props<{ cart: Partial<InteractionPublic> }>(),
    'Order Updated': props<{ orderId: string, order: Partial<InteractionPublic> }>(),
    'Interactions Removed': props<{ orderIds: string[] }>(),
    'Order Removed': props<{ orderId: string }>(),
    'All Interactions Removed': emptyProps(),
    'Reset Bubble Alerts': ( bubbles?: BubbleAlerts) => ({bubbles}),
    'Add Bubbles': ( bubbles: BubbleAlerts) => ({bubbles}),
    'toggle Interactions Showing': props<{ fulfillmentId: string, open: boolean | null}>(),
  }
});

const reducer = createReducer(
  getInteractionsState(),
  on(InteractionsPageActions.interactionsLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(InteractionsPageActions.interactionsLoaded, (state, action) =>
    adapter.upsertMany(action.interactions, { ...state, isLoading: false })
  ),
  on(InteractionsPageActions.interactionsRemoved, (state, action) =>
    adapter.removeMany(action.orderIds, { ...state, isLoading: false })
  ),
  on(InteractionsPageActions.orderRemoved, (state, action) =>
    adapter.removeOne(action.orderId, { ...state, isLoading: false })
  ),
  on(InteractionsPageActions.allInteractionsRemoved, (state) =>
    adapter.removeAll({ ...state, isLoading: false })
  ),
  on(AuthUserActions.logOut, () => getInteractionsState()),
  on(InteractionsPageActions.resetBubbleAlerts, (state, action) => ({...state, bubbleAlerts: setBubbles(action.bubbles) })),
  on(InteractionsPageActions.addBubbles, (state, action) => ({ ...state, bubbleAlerts: setBubbles(action.bubbles, state.bubbleAlerts)})),
  on(InteractionsPageActions.toggleInteractionsShowing, (state, {fulfillmentId, open}) => {
    const currFulfillment = {...state.fulfillmentEntriesShowing};
    currFulfillment[fulfillmentId] = open === null ? !currFulfillment[fulfillmentId] : open
    return {...state, fulfillmentEntriesShowing: currFulfillment}
  })
);

export const interactionsFeature = createFeature({
  name: 'interactions',
  reducer,
  extraSelectors: ({ selectEntities, selectIds, selectFulfillmentEntriesShowing, selectBubbleAlerts }) => ({
    selectInteractions: createSelector(
      selectIds,
      selectEntities,
      (ids, entities) => ids ? ids.map((id) => entities[id]) : []
    ),
    selectTotalBubbles: createSelector(
      selectBubbleAlerts,
      (bubbleAlert) => bubbleAlert.banking.size + bubbleAlert.fulfillment.size + bubbleAlert.purchase.size + bubbleAlert.shipping.size
    ),
    selectTotalUnseenBubbles: createSelector(
      selectBubbleAlerts,
      (bubbleAlert) => bubbleAlert.unseen.size
    ),
    selectInteractionsByFulfillmentId: createSelector(
      selectIds,
      selectEntities,
      selectFulfillmentEntriesShowing,
      (ids, entities, showing) => ids ? ids.reduce((a, id) => { 
        const interaction:InteractionPublic | undefined = entities[id];
        if(!interaction) return a;
        const fulfillmentId = interaction?.fulfillment.id || "_unknown_"
        if(!a[fulfillmentId]) a[fulfillmentId] = {show: showing[fulfillmentId], entries:[]};
        a[fulfillmentId].entries.push(interaction);
        a[fulfillmentId].entries.sort(sortByKey('createdAt',-1))
        return a;
      }, {} as {[fulfillmentId: string]: InteractionView}) : {}
    ),
  })
});
